import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import authContext from '../../context/authContext/authContext';
import Loader from '../../utils/Loader';
import './stepper.css';
import RenderError from '../../utils/RenderError';

const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const MOBILE_NUMBER_REGEX_PATTERN = /^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/;

const initialState = {
  step: 1,
  name: '',
  email: '',
  phone: '',
  dob: '',
  aadhar: '',
  pan: '',
}

const initialErrorState = {
  nameError: '',
  emailError: '',
  phoneError: '',
  dobError: '',
  aadharError: '',
  panError: '',
  selectProductError: ''
}

const RenderVerificationIcon = ({ value }) => {
  const className = `fa fa-${value ? 'check text-success' : 'times text-danger'}`;
  return <i className={className} />;
};

const SelectProductModal = ({ isOpen, toggle, products, getProducts, parentId, loading, selectedProductId, selectProduct }) => {
  const dispatch = useDispatch();
  const { getConfig, user } = useContext(authContext);
  const config = getConfig();

  const [state, setCompleteState] = useState({ ...initialState, ...initialErrorState, ...user })
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  useEffect(() => {
    if (user && state.step === 2) {
      setState({ ...user })
    }
  }, [user, state.step]);

  const handleSubmit = () => {
    const data = { productId: selectedProductId }
    selectProduct(data, onHideModal);
    // window.open('https://mosl.co/xTQkoY8sSg', '_blank', 'noopener,noreferrer')
  }

  const handleStepUp = () => {
    const currrentStep = state.step;
    if (currrentStep >= 2) {
      return;
    }

    setState({ step: currrentStep + 1 });
  };

  const handleStepDown = () => {
    const currrentStep = state.step;
    if (currrentStep <= 1) {
      return;
    }

    setState({ step: currrentStep - 1 });
  };

  const validateName = () => {
    if (state.name.trim() === '') {
      setState({ nameError: '*Name is required!' })
    }
  }

  const validateEmail = () => {
    const isValidEmail = EMAIL_REGEX_PATTERN.test(state.email);
    if (!isValidEmail) {
      setState({ emailError: '*Please enter a valid email!' })
    }
  }

  const validateAadhar = () => {
    const aadharNumber = state.aadhar.trim();
    if (!aadharNumber || aadharNumber.length !== 12) {
      setState({ aadharError: '*Invalid Aadhar card number!' })
    }
  }

  const validatePan = () => {
    const panNumber = state.pan.trim();
    if (!panNumber || panNumber.length !== 10) {
      setState({ panError: '*Invalid Aadhar card number!' })

    }
  }

  const validateDob = () => {
    if (state.dob.trim() === '') {
      setState({ dobError: '*DOB is required!' })
    }
  }

  const validatePhoneNumber = () => {
    if (!state.phone || !MOBILE_NUMBER_REGEX_PATTERN.test(state.phone)) {
      setState({ phoneError: '*Provide valid indian numbers' })
    }
  }

  const toDisplayFormat = (value) => {
    // YYYY-MM-DD → DD/MM/YYYY
    if (!value) return "";
    const [yyyy, mm, dd] = value.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const toInputFormat = (value) => {
    // DD/MM/YYYY → YYYY-MM-DD
    if (!value) return "";
    const [dd, mm, yyyy] = value.split("/");
    return `${yyyy}-${mm}-${dd}`;
  };

  const verifyAllFields = () => {
    const { name, email, phone, dob, aadhar, pan } = state;
    const objValues = Object.values({ name, email, phone, dob, aadhar, pan });
    const hasMissingFields = objValues.some(value => !value);
    return hasMissingFields;
  }

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal}>
        <div className='d-flex align-items-center'>
          <div className='fw-600'>Select Product</div>
          <div className='ml-3'>
            <Loader isLoading={loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='steps-container'>
          <div className="stepper-wrapper">
            <div className="step-wrapper">
              <div className={`step-number ${state.step >= 1 ? 'completed' : ''}`}>1</div>
            </div>
            <div className={`stepper-line ${state.step >= 2 ? 'completed' : ''}`}></div>
            <div className="step-wrapper">
              <div className={`step-number ${state.step >= 2 ? 'completed' : ''}`}>2</div>
            </div>
          </div>
        </div>
        <div className='text-center mb-2'>
          <img src="assets/img/motilal-oswal-logo.png" style={{ height: '8rem' }} class="navbar-brand-image d-inline-block align-top mr-2" alt="" />
        </div>

        <div className='item-step-1' hidden={state.step !== 1}>
          <div className='row ml-2'>
            <div className='col-md-6'>
              <div className='how-this-workning'>
                <label className='mb-2 fw-600'>How this works</label>
                <div className='ml-2'>
                  <div className='mb-2'>
                    <div>➡️ Register on our platform</div>
                    <small className='ml-4' style={{ fontSize: 12 }}>Complete the registration form to get started.</small>
                  </div>
                  <div className='mb-2'>
                    <div>➡️ Verification Period (Up to 24 hours)</div>
                    <small className='ml-4' style={{ fontSize: 12 }}>Allow up to 24 hours for our team to review your details.</small>

                  </div>
                  <div className='mb-2'>
                    <div>➡️ Agent Callback </div>
                    <small className='ml-4' style={{ fontSize: 12 }}>One of our agents will contact you within 24 hours.</small>
                  </div>
                  <div className='mb-2'>
                    <div>➡️ Didn't receive a call?</div>
                    <small className='ml-4' style={{ fontSize: 12 }}>You can reach out to us by using provided contact details.</small>
                  </div>
                  <div className='mb-2'>🎉 Earn reward points automatically!</div>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='benefits'>
                <div className='mb-2 fw-600'>Here are the top benefits your user gets:</div>
                <div className='ml-2'>
                  <div className='mb-2'>✅ 100% Free Demat & Trading Account</div>
                  <div className='mb-2'>✅ Earn Reward Tokens</div>
                  <div className='mb-2'>✅ Trusted by Millions</div>
                  <div className='mb-2'>✅ Zero Brokerage Offers</div>
                  <div className='mb-2'>✅ Full Support From Our Team</div>
                </div>
              </div>
            </div>
          </div>

          <div className='mt-3 ml-2 note'>
            <div className='fw-600 mb-1'>Important Points:</div>
            <div className='ml-2'>
              <div className='mb-1'>1. You must need to register with your valid documents.</div>
              <div className='mb-1'>2. Once your account is successfully activated, your reward tokens will be added automatically to your dashboard within 24–48 hours.</div>
              <div className='mb-1'>3. Phone number must be linked with aadhar and pan card.</div>
              <div className='mb-1'>4. Make sure to add your nominee details while opening a DEMAT account.</div>
            </div>
          </div>
        </div>

        <div className='item-step-2' hidden={state.step !== 2}>
          {/* <form className='row mx-2'>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label for="exampleDropdownFormName" class="form-label">Name*</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter your name"
                  value={state.name}
                  onFocus={() => setState({ nameError: '', selectProductError: '' })}
                  onChange={(e) => setState({ name: e.target.value })}
                  onBlur={validateName}
                  disabled={state.loading}
                />
                <RenderError error={state.nameError} />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label for="exampleDropdownFormEmail1" class="form-label">Email address*</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleDropdownFormEmail1"
                  placeholder="email@example.com"
                  value={state.email}
                  onChange={(e) => setState({ email: e.target.value })}
                  onFocus={() => setState({ emailError: '', selectProductError: '' })}
                  onBlur={validateEmail}
                  disabled={state.loading}
                />
                <RenderError error={state.emailError} />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">Phone number*</label>
                <input
                  type="email"
                  class="form-control"
                  value={state.phone}
                  onChange={(e) => setState({ phone: e.target.value })}
                  onFocus={() => setState({ phoneError: '', selectProductError: '' })}
                  onBlur={validatePhoneNumber}
                  disabled={state.loading}
                />
                <small className='form-text text-muted'>Pattern: +91XXXXXXXXXX</small>
                <RenderError error={state.phoneError} />
              </div>
            </div>
            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">DOB*</label>
                <div>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    class="form-control"
                    value={toInputFormat(state.dob)}
                    pattern="\d{2}/\d{2}/\d{4}"
                    onChange={(e) => setState({ dob: toDisplayFormat(e.target.value) })}
                    onFocus={() => setState({ dobError: '', selectProductError: '' })}
                    onBlur={validateDob}
                    disabled={state.loading}
                  />
                  <div className='form-text text-muted'>Format: DD/MM/YYYY</div>
                </div>
                <RenderError error={state.dobError} />
              </div>

            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">Aadhar number*</label>
                <input
                  type="number"
                  class="form-control"
                  value={state.aadhar}
                  onChange={(e) => setState({ aadhar: e.target.value })}
                  onFocus={() => setState({ aadharError: '', selectProductError: '' })}
                  onBlur={validateAadhar}
                  disabled={state.loading}
                />
                <RenderError error={state.aadharError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">Pan number*</label>
                <input
                  type="number"
                  class="form-control"
                  value={state.pan}
                  onChange={(e) => setState({ pan: e.target.value })}
                  onFocus={() => setState({ panError: '', selectProductError: '' })}
                  onBlur={validatePan}
                  disabled={state.loading}
                />
                <RenderError error={state.panError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">Nominee</label>
                <div>
                  <select
                    className='custom-product-select w-100'
                    value={state.nominee}
                    onChange={(e) => setState({ nominee: e.target.value })}
                    disabled={state.loading}
                  >
                    <option>Select Nominee</option>
                    <option>Father</option>
                    <option>Mother</option>
                    <option>Wife</option>
                    <option>Brother</option>
                    <option>Other</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='col-md-6'>
              <div class="form-group mb-3">
                <label class="form-label">Nominee Name</label>
                <input
                  type="text"
                  class="form-control"
                  value={state.nomineeName}
                  onChange={(e) => setState({ nomineeName: e.target.value })}
                  disabled={state.loading}
                />
              </div>
            </div>

            <div className='pb-3 text-center'>
              <Loader isLoading={state.loading} />
            </div>
            <div className='text-center fw-500 mt-2'><small className='text-danger'>
              <RenderError error={state.selectProductError} />
            </small></div>
          </form> */}

          <div className='verification-checklist mx-2'>
            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>Name</span>
              <RenderVerificationIcon value={user?.name} />
            </div>

            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>Email</span>
              <RenderVerificationIcon value={user?.email} />
            </div>

            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>Phone</span>
              <RenderVerificationIcon value={user?.phone} />
            </div>

            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>DOB</span>
              <RenderVerificationIcon value={user?.dob} />
            </div>

            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>Aadhar number</span>
              <RenderVerificationIcon value={user?.aadhar} />
            </div>

            <div className='mb-2'>
              <span className='mx-2'>➡️</span>
              <span className='mr-2'>Pan number</span>
              <RenderVerificationIcon value={user?.pan} />
            </div>

            <div className='mt-4' hidden={!verifyAllFields()}>
              <RenderError
                error="*Update required fields in your account"
                className='fs-16'
              />

              <Link to="/profile" className='ml-2'>
                Edit profile
              </Link>
            </div>
          </div>


        </div>

      </ModalBody>
      <ModalFooter className='justify-content-between'>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <div>
          <Button color="outline-secondary mx-2" onClick={handleStepDown} disabled={loading || state.step === 1} hidden={state.step === 1}>
            Previous
          </Button>
          <Button color="outline-primary  mx-2" onClick={handleStepUp} disabled={loading || state.step === 2} hidden={state.step === 2}>
            Next
          </Button>
          <Button
            color="gleamdesk mx-2"
            onClick={handleSubmit}
            disabled={loading || state.step !== 2 || verifyAllFields()}
            hidden={state.step !== 2}
          >
            Select Product
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default SelectProductModal
